import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { DatiDDTPRModalComponent } from './dati-ddt-pr-modal';

export const DatiDDTPRModalModule: string = ng
    .module('dati-ddt-pr-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('datiDDTPRModalComponent', DatiDDTPRModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/dati-ddt-pr-modal/dati-ddt-pr-modal.module.ts